export default {
    it: {
        "go-back": "Torna indietro",
        "new-quiz": "Inizia nuovo questionario",
        "torna-home": "ok! Torna in Homepage"
    },
    en: {
        "go-back": "Go back",
        "new-quiz": "Start new quiz",
        "torna-home": "ok! Go back to Homepage"
    }
}